/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListSavedViewsRequest
 */
export interface ListSavedViewsRequest {
    /**
     * 
     * @type {number}
     * @memberof ListSavedViewsRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the ListSavedViewsRequest interface.
 */
export function instanceOfListSavedViewsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function ListSavedViewsRequestFromJSON(json: any): ListSavedViewsRequest {
    return ListSavedViewsRequestFromJSONTyped(json, false);
}

export function ListSavedViewsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSavedViewsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function ListSavedViewsRequestToJSON(value?: ListSavedViewsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
    };
}

